// Greenfield Production State helper — quando o usuário autenticado é `syllas@giyus.com.br`
// (Administrador Full / SUPER_USER) ou o ambiente é Produção (`prod`), o portal opera em modo
// Greenfield limpo (sem dados demo/mock) e sem nenhum simulador/simulação (restritos a `dev`).

export const GREENFIELD_ADMIN_USER_ID = '01926f3e-0000-7000-8000-000000000099';
export const GREENFIELD_ADMIN_EMAIL = 'syllas@giyus.com.br';

export interface ActiveGiyusDirectoryUser {
  readonly id: string;
  readonly displayName: string;
  readonly givenName: string;
  readonly familyName: string;
  readonly email: string;
  readonly jobTitle: string;
  readonly department: string;
  readonly primaryRole: string;
  readonly defaultPersonaLens: 'clinical' | 'operations' | 'financial' | 'admin' | 'external';
  readonly isSuperAdmin?: boolean;
}

/**
 * Catálogo oficial dos usuários humanos ativos (`accountEnabled: true`) no locatário
 * Microsoft Entra ID `@giyus.com.br` para seleção rápida ao adicionar usuários.
 */
export const ACTIVE_GIYUS_DIRECTORY_USERS: readonly ActiveGiyusDirectoryUser[] = [
  {
    id: '7c73f26b-3aec-4665-9c94-ea0393371104',
    displayName: 'Syllas de Souza',
    givenName: 'Syllas',
    familyName: 'Souza',
    email: 'syllas@giyus.com.br',
    jobTitle: 'CEO / Administrador Master',
    department: 'Diretoria',
    primaryRole: 'SUPER_ADMIN',
    defaultPersonaLens: 'admin',
    isSuperAdmin: true,
  },
  {
    id: '71b4d33b-0351-4aee-9083-d9b349573b4a',
    displayName: 'Herberto Jose Chong Neto',
    givenName: 'Herberto Jose',
    familyName: 'Chong Neto',
    email: 'chong.neto@giyus.com.br',
    jobTitle: 'Diretor Médico & Pesquisador Principal',
    department: 'Diretoria Médica',
    primaryRole: 'PRINCIPAL_INVESTIGATOR',
    defaultPersonaLens: 'clinical',
  },
  {
    id: '4f588ef1-b093-4cc2-90d6-f7ed039189e3',
    displayName: 'Eduarda Sampaio Lazzarotto',
    givenName: 'Eduarda',
    familyName: 'Sampaio Lazzarotto',
    email: 'eduarda.lazzarotto@giyus.com.br',
    jobTitle: 'Operações & Pesquisa Clínica',
    department: 'Operações Clínicas',
    primaryRole: 'CLINICAL_COORDINATOR',
    defaultPersonaLens: 'operations',
  },
  {
    id: '2d93e2f2-5b86-4db2-9529-8b92b56914d2',
    displayName: 'Elessandra Bitencourt',
    givenName: 'Elessandra',
    familyName: 'Bitencourt',
    email: 'elessandra@giyus.com.br',
    jobTitle: 'Coordenadora de Pesquisa Clínica',
    department: 'Coordenação Clínica',
    primaryRole: 'CLINICAL_COORDINATOR',
    defaultPersonaLens: 'operations',
  },
  {
    id: 'da42761e-4f79-45f9-8390-07614542581b',
    displayName: 'Gabriel Vinicius Cordeiro',
    givenName: 'Gabriel',
    familyName: 'Vinicius Cordeiro',
    email: 'gabriel.cordeiro@giyus.com.br',
    jobTitle: 'Operações & Contratos',
    department: 'Operações',
    primaryRole: 'CONTRACT_ANALYST',
    defaultPersonaLens: 'operations',
  },
  {
    id: '14a89876-26c4-40ef-b302-ef4b0f928797',
    displayName: 'Gustavo Resende da Costa',
    givenName: 'Gustavo',
    familyName: 'Resende da Costa',
    email: 'gustavo.costa@giyus.com.br',
    jobTitle: 'Financeiro & Controladoria',
    department: 'Financeiro',
    primaryRole: 'FINANCE_CONTROLLER',
    defaultPersonaLens: 'financial',
  },
  {
    id: '391e230c-2095-45fe-8855-29d90c8dccf3',
    displayName: 'Laura Holtman Ferreira',
    givenName: 'Laura',
    familyName: 'Holtman Ferreira',
    email: 'laura.ferreira@giyus.com.br',
    jobTitle: 'Pesquisa Clínica',
    department: 'Operações Clínicas',
    primaryRole: 'CLINICAL_COORDINATOR',
    defaultPersonaLens: 'operations',
  },
  {
    id: 'a86784c5-235d-44c7-a21c-5794a486bfcc',
    displayName: 'Lucilia Conceição Pinto',
    givenName: 'Lucilia',
    familyName: 'Conceição Pinto',
    email: 'lucilia.pinto@giyus.com.br',
    jobTitle: 'Qualidade & Regulatório',
    department: 'Qualidade & Regulatório',
    primaryRole: 'CLINICAL_COORDINATOR',
    defaultPersonaLens: 'operations',
  },
  {
    id: '14b3295e-303c-406f-9095-4e3a2288f413',
    displayName: 'Mariana Wolff Sereneski Linero',
    givenName: 'Mariana',
    familyName: 'Wolff Sereneski Linero',
    email: 'mariana.linero@giyus.com.br',
    jobTitle: 'Pesquisa Clínica',
    department: 'Operações Clínicas',
    primaryRole: 'CLINICAL_COORDINATOR',
    defaultPersonaLens: 'operations',
  },
  {
    id: 'b9eb4da6-cc82-4f1f-95a7-d01fc67320f9',
    displayName: 'Micaela Hedeke Paim Mendes',
    givenName: 'Micaela',
    familyName: 'Hedeke Paim Mendes',
    email: 'micaela.mendes@giyus.com.br',
    jobTitle: 'Pesquisa Clínica',
    department: 'Operações Clínicas',
    primaryRole: 'CLINICAL_COORDINATOR',
    defaultPersonaLens: 'operations',
  },
  {
    id: 'e0777381-8b7d-461e-8eb4-416d331abc60',
    displayName: 'Sandra Candido',
    givenName: 'Sandra',
    familyName: 'Candido',
    email: 'sandra.candido@giyus.com.br',
    jobTitle: 'Administração & Operações',
    department: 'Operações',
    primaryRole: 'MANAGER',
    defaultPersonaLens: 'operations',
  },
  {
    id: 'e8e7719d-c777-4f74-8284-4ac48c1f43cf',
    displayName: 'Thays Fischer',
    givenName: 'Thays',
    familyName: 'Fischer',
    email: 'thays.fischer@giyus.com.br',
    jobTitle: 'Pesquisa Clínica',
    department: 'Operações Clínicas',
    primaryRole: 'CLINICAL_COORDINATOR',
    defaultPersonaLens: 'operations',
  },
];

export function isProductionRuntime(appEnv?: { readonly environment?: string } | null): boolean {
  if (appEnv?.environment === 'prod') {
    return true;
  }
  const viteEnv = (import.meta.env as unknown as Record<string, unknown> | undefined)?.[
    'VITE_ENVIRONMENT'
  ];
  if (viteEnv === 'prod') {
    return true;
  }
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const port = window.location.port;
    if (
      host === 'app.giyus.com.br' ||
      host.endsWith('.giyus.com.br') ||
      host.endsWith('.azurestaticapps.net') ||
      host.endsWith('.web.core.windows.net') ||
      port === '4174'
    ) {
      return true;
    }
  }
  return false;
}

/**
 * REGRA INEGOCIÁVEL:
 * - Simulações que criam informações inúteis/fictícias no sistema (ex.: simular recebimento de e-mail,
 *   simular nota fiscal, simular aceite de token, auto-preencher pedidos fictícios) são PROIBIDAS (`false`).
 * - Simulações analíticas exclusivamente para fins de tomada de decisão (`isDecisionSimulationEnabled`)
 *   (ex.: cenários MiroFish, sensibilidade de recrutamento/margem, impacto de janela protocolar) são PERMITIDAS (`true`)
 *   e nunca criam registros fictícios no sistema.
 */
export function isSimulationAllowed(_appEnv?: { readonly environment?: string } | null): boolean {
  return false;
}

export function isDecisionSimulationEnabled(): boolean {
  return true;
}

export function isGreenfieldAdminEmail(email: string | null | undefined): boolean {
  if (isProductionRuntime()) {
    return true;
  }
  return (email ?? '').trim().toLowerCase() === GREENFIELD_ADMIN_EMAIL;
}

export function isGreenfieldAdmin(
  me: { readonly user?: { readonly id?: string; readonly email?: string } } | null | undefined,
): boolean {
  if (isProductionRuntime()) {
    return true;
  }
  if (!me?.user) {
    return false;
  }
  return me.user.id === GREENFIELD_ADMIN_USER_ID || isGreenfieldAdminEmail(me.user.email);
}

/**
 * Verifica se o usuário autenticado é o Super Admin Master da plataforma GIYUS
 * (`Syllas de Souza` / `syllas@giyus.com.br` / `SUPER_USER` / `SUPER_ADMIN`),
 * que possui autorização irrestrita (`ALL_FULL_ADMIN_PERMISSIONS`) em todos os módulos,
 * incluindo Documentos (rede e todos os centros).
 */
export function isSuperAdminUser(
  me:
    | {
        readonly user?: {
          readonly id?: string;
          readonly email?: string;
          readonly displayName?: string;
        };
        readonly networkAccess?: {
          readonly hasAccess?: boolean;
          readonly roles?: readonly string[];
        };
      }
    | null
    | undefined,
): boolean {
  if (!me?.user) {
    return false;
  }
  const email = (me.user.email ?? '').trim().toLowerCase();
  const displayName = (me.user.displayName ?? '').trim().toLowerCase();
  if (
    me.user.id === GREENFIELD_ADMIN_USER_ID ||
    me.user.id === '7c73f26b-3aec-4665-9c94-ea0393371104' ||
    me.user.id === '00000000-0000-7000-8000-0000000000a1' ||
    email === GREENFIELD_ADMIN_EMAIL ||
    displayName.includes('syllas')
  ) {
    return true;
  }
  const roles = me.networkAccess?.roles ?? [];
  return roles.includes('SUPER_USER') || roles.includes('SUPER_ADMIN');
}
